import { reactive, ref, computed, onMounted, watch, onBeforeMount } from '@vue/composition-api'

import store from '@/store'
import * as _ from 'lodash'

export const NoteUserPermissionsEdit = (props, context) => {

  onMounted(() => {

    const parentType = store.state.noteUserPermissionsEdit.parentType
    
    if (parentType === 'edit') {
      state.shareClassification = store.state.note.detailEdit.share_classification
    } else if (parentType === 'select') {
      state.shareClassification = store.state.noteSelect.share_classification
    } else {
      // 変数指定間違い（ここに来る場合はバグ）
      return
    }

    // ウィンドウタイトル
    let shareClassificationName = ''
    if (state.shareClassification === 21) {
      shareClassificationName = '閲覧'
    } else if (state.shareClassification === 22) {
      shareClassificationName = '編集'
    }
    state.windowTitle = shareClassificationName + '権限を付与するアカウントを指定'

    // キーワード入力欄のフォーカス状態（SP専用）
    if (store.state.common.device === 'sp') {
      if (context.refs.focusInput) {
        context.refs.focusInput.addEventListener('focus', (event) => {
          state.isFocusedInput = true
        })
        context.refs.focusInput.addEventListener('blur', (event) => {
          state.isFocusedInput = false
        })
      }
    }

    // ノート利用者権限一覧情報を取得
    state.isDataLoaded = false
    let actionName
    if (parentType === 'edit') {
      actionName = 'note/getUserPermissions' 
    } else if (parentType === 'select') {
      actionName = 'noteSelect/getUserPermissions'
    }
    store.dispatch(actionName, { isShareUsersSet: false })
      .then((response) => {

        let shareUsersViewable
        let shareUsersEditable
        if (parentType === 'edit') {
          state.allList = store.getters['note/userPermissions']
          shareUsersViewable = store.getters['note/shareUsersViewable']
          shareUsersEditable = store.getters['note/shareUsersEditable']
        } else if (parentType === 'select') {
          state.allList = store.getters['noteSelect/userPermissions']
          shareUsersViewable = store.getters['noteSelect/shareUsersViewable']
          shareUsersEditable = store.getters['noteSelect/shareUsersEditable']
        }
        state.list = state.allList
         
        // 権限のあるユーザーのチェックボックスにチェックする
        const userIdsWork = []
        if (state.shareClassification === 21 && shareUsersViewable.length > 0) {
          // 閲覧可で、すでにユーザーをチェックをしている場合
          for (let i = 0; i < shareUsersViewable.length; i++) {
            const userId = shareUsersViewable[i].id
            userIdsWork.push(userId)
          }
        } else if (state.shareClassification === 22 && shareUsersEditable.length > 0) {
          // 編集可で、すでにユーザーをチェックをしている場合
          for (let i = 0; i < shareUsersEditable.length; i++) {
            const userId = shareUsersEditable[i].id
            userIdsWork.push(userId)
          }
        }
        userIdsWork.sort() // _.isEqual()で比較するため昇順にソート
        state.user_ids = userIdsWork

        // 全ユーザーをチェックしている場合は、「すべてをチェック」のチェックボックスをチェックする
        const allUserIds = []
        for (let i = 0; i < state.allList.length; i++) {
          const userId = state.allList[i].id
          allUserIds.push(userId)
        }
        allUserIds.sort() // _.isEqual()で比較するため昇順にソート
        if (_.isEqual(state.user_ids, allUserIds)) {
          state.isAllSelected = true
        }
      })
      .finally(() => {
        state.isDataLoaded = true        
      })
  })

  const state = reactive({
    profileId: computed(() => store.state.profile.id), // 自分(ログインユーザー)のID
    shareClassification: null, // 処理対象の共有区分(21=閲覧可、22=編集可)
    isFocusedInput: false, // テキストフィールドのフォーカス表示フラグ（SP用）
    windowTitle: '', // ウィンドウタイトル
    isAllSelected: false, // すべて選択する
    allList: [], // 全リスト
    list: [], // キーワード検索で絞り込んだ表示中のリスト
    user_ids: [], // チェックボックスにチェックされているユーザーIDのリスト
    search_text: '', // 検索キーワード
    isDataLoaded: false, // データロード完了フラグ

    /**
     * キーワード検索
     */
    search: () => {
      const searchText = state.search_text.trim()

      // キーワードに一致する名前をもつユーザーを抽出し、新しい表示中のリストに設定する
      const listWork = []
      for (let i = 0; i < state.allList.length; i++) {
        const map = state.allList[i]
        const userName = map.name
        if (userName.indexOf(searchText) >= 0) {
          listWork.push(map)
        }
      }
      state.list = listWork
    },

    /**
     * 設定ボタン押下時
     */
    submit: () => {
      const parentType = store.state.noteUserPermissionsEdit.parentType

      const shareUsers = []
      for (let i = 0; i < state.user_ids.length; i++) {
        const id = state.user_ids[i]
        const type = state.shareClassification
        const map = {
          id: id,
          type: type
        }
        shareUsers.push(map)
      }

      if (parentType === 'edit') {
        store.dispatch('note/setShareUsersDetailEdit', shareUsers)
        if (state.shareClassification === 21) {
          // 閲覧可の場合
          store.dispatch('note/setShareUsersViewable', shareUsers)
        } else if (state.shareClassification === 22) {
          // 編集可の場合
          store.dispatch('note/setShareUsersEditable', shareUsers)
        }
      } else if (parentType === 'select') {
        store.dispatch('noteSelect/setShareUsers', shareUsers)
        if (state.shareClassification === 21) {
          // 閲覧可の場合
          store.dispatch('noteSelect/setShareUsersViewable', shareUsers)
        } else if (state.shareClassification === 22) {
          // 編集可の場合
          store.dispatch('noteSelect/setShareUsersEditable', shareUsers)
        }
      }

      // 本ウィンドウを閉じる
      close()
    }
  })

  /**
   * 本ウィンドウを閉じる
   */
  const close = () => {
    context.emit('close')
  }

  /**
   * 全て選択する
   */
  const checkAll = () => {
    if (state.isAllSelected) {
      // すべてチェックがON
      const allUserIds = state.allList.map((obj) => {
        return obj.id
      })
      state.user_ids = allUserIds
    } else {
      // すべてチェックがOFF
      state.user_ids = []
    }
  }

  /**
   * 権限の変更を行う際に全て選択を付与したり解除したりする
   */
  const checkSelectedLength = () => {

    // 全ユーザー
    const allUsersMap = {}
    for (let i = 0; i < state.allList.length; i++) {
      const userId = state.allList[i].id
      allUsersMap[userId] = 1
    }

    // 自分は一覧に表示されないので除いておく
    delete allUsersMap[state.profileId] 
    // チェックされているユーザー
    for (let i = 0; i < state.user_ids.length; i++) {
      const userId = state.user_ids[i]
      delete allUsersMap[userId]
    }

    // チェックされていないユーザーの数
    const leftKeyNum = Object.keys(allUsersMap).length

    if (leftKeyNum === 0) {
      // すべてチェックをON
      state.isAllSelected = true
    } else {
      // すべてチェックをOFF
      state.isAllSelected = false
    }
  }

  return {
    state,
    close,
    checkAll,
    checkSelectedLength
  }
}
